import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { toast } from "sonner";
import api, { authStore } from "@/lib/api";

export default function Login() {
    const [email, setEmail] = useState("");
    const [password, setPassword] = useState("");
    const [loading, setLoading] = useState(false);
    const nav = useNavigate();

    const submit = async (e) => {
        e.preventDefault();
        setLoading(true);
        try {
            const { data } = await api.post("/auth/login", { email, password });
            authStore.setSession(data.token, data.user);
            toast.success("Signed in");
            nav("/");
        } catch (err) {
            toast.error(err?.response?.data?.detail || "Invalid credentials");
        }
        setLoading(false);
    };

    return (
        <main data-testid="login-page" className="pt-[72px] min-h-screen bg-[#0B1930] text-white flex items-center justify-center">
            <form onSubmit={submit} className="w-full max-w-md bg-white text-navy rounded-2xl p-8">
                <div className="eyebrow eyebrow--slate">Sign in</div>
                <h1 className="font-serif text-3xl mt-3">Welcome back.</h1>
                <div className="mt-6 space-y-4">
                    <input data-testid="login-email" type="email" required placeholder="Email" value={email} onChange={(e) => setEmail(e.target.value)} className="w-full border border-slate-200 rounded-md px-4 py-3" />
                    <input data-testid="login-password" type="password" required placeholder="Password" value={password} onChange={(e) => setPassword(e.target.value)} className="w-full border border-slate-200 rounded-md px-4 py-3" />
                    <button data-testid="login-submit" disabled={loading} className="btn-primary w-full justify-center">{loading ? "Signing in…" : "Sign in"}</button>
                    <p className="text-center text-sm text-slate-500">No account? <Link to="/register" className="text-navy underline">Register</Link></p>
                </div>
            </form>
        </main>
    );
}
